class MFRTimedCarousel {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      items: "> *",
      bar: ".flickity-page-dots .dot.is-selected",
      allBars: ".flickity-page-dots .dot",
      sliderProducts: ".text-with-carousel__products",
      sliderLogos: ".carousel__navigation",
      sliderSpinner: ".carousel__spinner"
    };

    this.flickityOptions = options.flickityOptions;
    this.autoplayTiming = options.autoplayTiming;
    this.timingArgs = {
      percentTime: 0,
      isPaused: false,
    };

    this.customNav = options.customNav;
    this.logoNav = options.logoNav;
    this.spinner = options.spinner;

    this.init();
  }

  init() {
    this.$slider = this.$element;
    this.$item = this.$element.find(this.selectors.items);
    this.$currentSlide = this.$element.find(this.selectors.currentSlide);
    this.$sliderProducts = $(this.selectors.sliderProducts);
    this.$sliderLogos = $(this.selectors.sliderLogos);
    this.$sliderSpinner = this.$element.siblings(this.selectors.sliderSpinner);

    setTimeout(() => {
      this.initCarousel();
      window.replaceFlickityArrows();
    }, 1300);

    $(window).on("resize", () => {
      if (this.$element.data("flickity")) this.initCarousel();
    });
  }

  initCarousel() {
    if (this.$item.length <= 1) return;
    this.$slider.flickity({
      ...this.flickityOptions,
      on: {
        change: () => {
          this.resetProgressbar();
          this.updateSlideIndicators();
          this.startProgressbar();
          this.logoNavigation();
          this.customSpinner();
        },
      },
    });
    
    this.updateSlideIndicators();
    this.startProgressbar();
    this.customNavigation();
    this.logoNavigation();
    this.customSpinner();
  }

  updateSlideIndicators() {
    const flkty = this.$slider.data("flickity");
    const currentSlideNumber = flkty.selectedIndex + 1;
    this.$allBars = this.$element.find(this.selectors.allBars);

    this.$currentSlide.text(currentSlideNumber);
  }

  startProgressbar() {
    this.resetProgressbar();
    this.timingArgs.percentTime = 0;
    this.timingArgs.isPaused = false;
    this.timingArgs.lastTimestamp = performance.now();
    this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this));
  }

  interval(timestamp) {
    if (!this.timingArgs.isPaused) {
      this.timingArgs.percentTime +=
        (timestamp - this.timingArgs.lastTimestamp) /
        (this.autoplayTiming * 1000); // Convert to seconds
      this.timingArgs.lastTimestamp = timestamp;

      if (this.timingArgs.percentTime >= 1) {
        this.$slider.flickity("next", true);
        this.startProgressbar();
      } else {
        this.$element.find(this.selectors.bar).css({
          "--dynamic-width":
            (this.timingArgs.percentTime * 100).toFixed(2) + "%",
        });
        this.timingArgs.tick = requestAnimationFrame(this.interval.bind(this));
      }
    }
  }

  resetProgressbar() {
    this.$allBars.css({
      "--dynamic-width": 0 + "%",
    });
    cancelAnimationFrame(this.timingArgs.tick);
  }

  customNavigation() {
    if (!this.customNav) return;

    this.$slider.on("change.flickity", (event, index) => {
      this.$sliderProducts.children(".product-item").removeClass("is-active");
      this.$sliderProducts.children(`.product-item[data-index="${index}"]`).addClass("is-active");
    });
  }

  logoNavigation() {
    if (!this.logoNav) return;

    const $mainSlider = this.$slider;

    this.$sliderLogos.children(".navigation__item").each(function() {
      $(this).on("click", function() {
        let index = $(this).data("index");
        $mainSlider.flickity("select", index);
      });
    });

    this.$slider.on("change.flickity", (event, index) => {
      this.$sliderLogos.children(".navigation__item").removeClass("is-active");
      this.$sliderLogos.children(`.navigation__item[data-index="${index}"]`).addClass("is-active");
    });
  }

  customSpinner() {
    if(!this.spinner) return;

    const loaderAnimate = () => {
      this.$sliderSpinner.removeClass("animate");
      void this.$sliderSpinner.offsetWidth;

      setTimeout(() => {
        this.$sliderSpinner.addClass("animate");
      }, 100);
    }

    this.$slider.on("ready.flickity", function() {
      loaderAnimate();
    });

    this.$slider.on("change.flickity", (event, index) => {
      loaderAnimate();
    });
  }
}